import React from "react";
import InfoCard from "../components/InfoCard";
import BackToTop from "../components/BackToTop";
import SearchBar from "../components/SearchBar";

export default function Cure({ turnOffAudio }) {
    const [search, setSearch] = React.useState("");
    const diseases = [
        {
            name: "Asthma",
            causes: "Genetic predisposition, allergic sensitisation (dust, pollen, pets), respiratory infections, air pollution, exercise, occupational exposures.",
            symptoms:
                "Wheezing, shortness of breath, chest tightness, coughing (often worse at night or early morning), rapid breathing.",
            image: "https://upload.wikimedia.org/wikipedia/commons/7/71/Illustration_of_lungs_and_other_visual_elements_related_to_asthma_research_-_2.jpg",
            prevention:
                "Identify and avoid triggers, improve indoor air quality, regular breathing exercises (pranayama/Buteyko), maintain healthy weight, follow vaccination and asthma action plan where needed.",
            references: [
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=JwRG8AsStLQ",
                    label: "Easy tips to treat Asthma & Bronchitis | Dr. Hansaji Yogendra"
                },
                {
                    type: "article",
                    url: "https://www.unanijournal.com/articles/283/8-2-12-874.pdf",
                    label: "A comprehensive review of bronchial asthma"
                }
            ]
        },
        {
            name: "Diabetes",
            causes: "Insulin resistance and impaired insulin secretion (Type 2), autoimmune beta-cell destruction (Type 1), strong genetic risk, obesity, sedentary lifestyle, high refined-carb intake.",
            symptoms:
                "Increased thirst, frequent urination, persistent fatigue, slow-healing wounds, blurred vision, unexplained weight change.",
            image: "https://upload.wikimedia.org/wikipedia/commons/2/29/Valentine%27s_chocolates_in_Japan_4.jpg",
            prevention:
                "Maintain healthy body weight, regular physical activity, high-fiber whole-food diet, limit refined sugars, manage stress and sleep, regular screening if at risk.",
            references: [
                {
                    type: "video",
                    url: "https://youtu.be/mK-os4mx5Sw?si=uM5F3LVruVqD4xzW",
                    label: "Diabetes Treatment | Success Stories | Acharya Manish Ji"
                },
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=gQgvXrmMZTU",
                    label: "30 सालों की शुगर 5 दिनों में हो गई ठीक | Swami Ramdev Ji |"
                },
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=-IWsuOJbjTc",
                    label: "Diabetic Diet -- 5 Simple Tips | By Dr. Bimal Chhajer | Saaol"
                }
            ]
        },
        {
            name: "Coronary Artery Disease (CAD)",
            causes: "Atherosclerosis from high LDL/cholesterol, hypertension, diabetes, smoking, obesity, sedentary lifestyle, genetic predisposition.",
            symptoms:
                "Chest pain or pressure (angina), shortness of breath on exertion, fatigue, palpitations; may be silent until an acute event (heart attack).",
            image: "https://upload.wikimedia.org/wikipedia/commons/f/f4/A_man_having_a_Heart_Attack.png",
            prevention:
                "Heart-healthy diet low in saturated fats and trans fats, regular aerobic exercise, quit smoking, control blood pressure and blood sugar, manage cholesterol, stress reduction and weight management.",
            references: [
                {
                    type: "video",
                    url: "https://www.youtube.com/shorts/gu0hl7SM-WA",
                    label: "5 Ayurvedic Drinks To Manage Heart Attack | SAAOL"
                },
                {
                    type: "article",
                    url: "https://www.thepharmajournal.com/archives/2014/vol3issue9/PartA/7-11-88-230.pdf",
                    label: "Cardio protective drugs in Unani medicine"
                }
            ]
        },
        {
            name: "Anemia",
            causes: "Iron deficiency from low dietary intake or malabsorption, chronic blood loss (menstruation, GI bleeding), vitamin B12 or folate deficiency, chronic disease.",
            symptoms:
                "Fatigue, pallor, weakness, dizziness, shortness of breath on exertion, rapid heartbeat, brittle nails or spooning (in iron deficiency).",
            image: "https://upload.wikimedia.org/wikipedia/commons/7/75/Blood_Test_%2815575812743%29.jpg",
            prevention:
                "Eat iron-rich vegetarian foods (lentils, spinach, legumes), pair iron with vitamin C for absorption, treat and investigate sources of blood loss, ensure adequate B12/folate intake when needed.",
            references: [
                {
                    type: "video",
                    url: "https://www.youtube.com/shorts/gurdwPUp6_0",
                    label: "How to Increase Iron and Hemoglobin naturally"
                },
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=YZpa2uE8htg",
                    label: "Anemia / Iron Deficiency - Cause & Cure | By Dr. Bimal Chhajer | Saaol"
                },
                {
                    type: "article",
                    url: "https://journals.lww.com/hjum/fulltext/2025/04000/the_concept_of_anemia_in_unani_system_of_medicine_.1.aspx",
                    label: "The Concept of Anemia in Unani System of Medicine"
                }
            ]
        },
        {
            name: "Stress",
            causes: "Work or life pressures, chronic psychosocial stressors, sleep deprivation, poor recovery habits, excessive stimulants (caffeine), unresolved emotional issues.",
            symptoms:
                "Irritability, anxiety, difficulty concentrating, sleep disturbance, muscle tension, headaches, digestive upset, fatigue.",
            image: "https://upload.wikimedia.org/wikipedia/commons/6/62/Canva_-_Woman_Feeling_Emotional_Stress.jpg",
            prevention:
                "Regular relaxation practices (breathwork, meditation, yoga), good sleep hygiene, regular physical activity, time management and boundaries, social support and healthy routines.",
            references: [
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=v-t1Z5-oPtU",
                    label: "How stress affects your body - Sharon Horesh Bergquist"
                },
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=8R2FfRl6V8U ",
                    label: "Yoga for Stress,Depression and Anxiety | Swami Ramdev"
                },
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=hz0QblZ5dtw",
                    label: "Ideas to Control Stress | By Dr. Bimal Chhajer | SAAOL"
                }
            ]
        },
        {
            name: "IBS (Irritable Bowel Syndrome)",
            causes: "Dysregulation of the gut–brain axis, post-infectious changes, food triggers, altered gut motility, stress and visceral hypersensitivity.",
            symptoms:
                "Recurrent abdominal pain or discomfort associated with altered bowel habits (diarrhea, constipation, or mixed), bloating, mucus in stool, urgency.",
            image: "https://upload.wikimedia.org/wikipedia/commons/8/86/Digestive_system_-_Intestine_segmentation_3_--_Smart-Servier.png",
            prevention:
                "Identify and avoid personal dietary triggers (trial low-FODMAP approach if needed), regular meals, adequate fiber tailored to IBS type, probiotics where helpful, stress management and gentle abdominal exercises/yoga.",
            references: [
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=HMBJjkqTwL0",
                    label: "Ayurvedic Treatment for Irritable Bowel Syndrome & Constipation"
                },
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=F_dzb9xBQQg",
                    label: "Autoimmune disease & Ulcerative colitis' Golden Key"
                }
            ]
        },
        {
            name: "Cancer",
            causes: "Genetic mutations and instability, exposure to carcinogens (tobacco, radiation, occupational chemicals), some viral infections (HPV, HBV), chronic inflammation, lifestyle factors (obesity, alcohol), age.",
            symptoms:
                "Variable by type — common warning signs include unexplained weight loss, persistent lumps or masses, unusual bleeding, persistent cough, changes in bowel/bladder habits, unexplained fatigue.",
            image: "https://upload.wikimedia.org/wikipedia/commons/b/bb/Tumor_Cells.png",
            prevention:
                "Avoid tobacco and excessive alcohol, maintain healthy weight and active lifestyle, balanced diet rich in fruits/vegetables, sun protection, vaccination where applicable (HPV/HBV), participate in recommended screening programs.",
            references: [
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=rlJSW46aWVc",
                    label: "Blood Cancer Treatment | Cured Through Ayurveda"
                },
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=c8-y6JEpY0U",
                    label: "Cancer Treatment | Cancer Prevention Diet |"
                }
            ]
        },
        {
            name: "Joint Pain",
            causes: "Osteoarthritis (wear-and-tear), prior injury, inflammatory arthritis (eg rheumatoid), overuse, mechanical strain, obesity.",
            symptoms:
                "Joint pain aggravated by use, stiffness (especially on waking), swelling or tenderness, reduced range of motion, crepitus in degenerative joints.",
            image: "https://upload.wikimedia.org/wikipedia/commons/1/19/Knee_pain.svg",
            prevention:
                "Maintain healthy body weight, regular low-impact strengthening and flexibility exercises, proper warm-up and technique for activities, anti-inflammatory diet, avoid repetitive overload and ensure good ergonomics.",
            references: [
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=LvCvJaki3ls",
                    label: "About Knee Pain Exercises | Dr. Bimal Chhajer | Saaol"
                },
                {
                    type: "video",
                    url: "https://www.youtube.com/watch?v=ifx5qDnUJBM",
                    label: "Knee Pain Treatment | Acharya Manish ji"
                }
            ]
        }
    ];

    const filtered = diseases.filter(
        d =>
            d.name.toLowerCase().includes(search.toLowerCase()) ||
            d.causes.toLowerCase().includes(search.toLowerCase()) ||
            d.prevention.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div
            style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: 24,
                fontFamily: "Segoe UI,Roboto,Arial,sans-serif",
                background: "linear-gradient(-45deg, #f8fffc 0%, #e0f7fa 50%, #d0f8e8 100%)",
                minHeight: "100vh"
            }}
        >
            <SearchBar
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search diseases, causes, prevention..."
            />
            {filtered.length === 0 && (
                <div style={{ textAlign: "center", color: "#888", fontSize: 20 }}>No results found.</div>
            )}
            {filtered.map(d => (
                <InfoCard turnOffAudio={turnOffAudio} key={d.name} {...d} section="cure" />
            ))}
            <BackToTop />
        </div>
    );
}
